import { MoreVert, Search } from "@mui/icons-material";
import {
    IconButton,
    InputAdornment,
    debounce,
    styled
} from "@mui/material";
import {
    ResettableTextField,
    useInput,
    type RaRecord,
    type TextInputProps,
} from "react-admin";

// @ts-expect-error asd
interface SearchInputProps<T extends RaRecord = RaRecord>
    extends TextInputProps {
    source: keyof T;
    onMore?: React.MouseEventHandler<HTMLButtonElement>;
}

export function SearchInput<T extends RaRecord = RaRecord>({
    defaultValue,
    format,
    parse,
    resource,
    source,
    validate,
    onBlur,
    onChange,
    onClick,
    onMore,
    alwaysOn = true,
    ...rest
}: SearchInputProps<T>): JSX.Element {
    const {
        field,
    } = useInput({
        defaultValue,
        format,
        parse,
        resource,
        source: source as string,
        type: "text",
        validate,
        onBlur,
        onChange,
        ...rest,
    });

    return (
        <StyledTextInput
            aria-label="Search"
            fullWidth
            variant="filled"
            helperText={false}
            resettable
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment sx={{ marginLeft: 0.5 }} position="end">
                            <IconButton
                                aria-label="Search"
                                onClick={onClick as any}
                            >
                                <Search color="secondary" />
                            </IconButton>
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <IconButton
                            color="secondary"
                            aria-label="Advanced Search"
                            size="large"
                            onClick={onMore}
                        >
                            {<MoreVert />}
                        </IconButton>
                    ),
                }
            }}
            onBlur={field.onBlur}
            onChange={debounce(field.onChange, 250)}
            {...rest}
        />
    );
}

const PREFIX = "RaSearchInput";

const StyledTextInput = styled(ResettableTextField, {
    name: PREFIX,
    overridesResolver: (_, styles) => styles.root,
})({
    "& .MuiFilledInput-root": {
        paddingRight: 4,
        paddingLeft: 7,
    },
    "& .MuiFilledInput-input": {
        paddingTop: 13,
        paddingBottom: 12,
        paddingLeft: 8,
        marginTop: 0,
    },
});
